export default{
  api_url:'http://10.0.70.70:8010'
}